(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Contracts_Delete_Dialog_Handler = (function(superClass) {
    extend(Contracts_Delete_Dialog_Handler, superClass);

    function Contracts_Delete_Dialog_Handler() {
      return Contracts_Delete_Dialog_Handler.__super__.constructor.apply(this, arguments);
    }

    Contracts_Delete_Dialog_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/contracts/load-layout-delete';
      this.saveUrl = 'backend/portal/contracts/delete-contract';
      this.classes = 'small_dialog';
      this.successAction = this.refreshContracts;
      return this.createDialog();
    };

    Contracts_Delete_Dialog_Handler.prototype.afterLoadLayout = function() {
      var ths;
      ths = this;
      this.openDialog();
      return this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          return _this.save('Deleting Contract');
        };
      })(this));
    };

    Contracts_Delete_Dialog_Handler.prototype.refreshContracts = function() {
      return this.parent.parent.unloadContract();
    };

    return Contracts_Delete_Dialog_Handler;

  })(DialogHandler);

}).call(this);
